import CAIA0050RequestModel from '@/api/data/CAI/CAIA0050/CAIA0050RequestModel'
import CAIA0050ResponseModel from '@/api/data/CAI/CAIA0050/CAIA0050ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CommonUtil from '@/common/utils/CommonUtil'

export default class CAIG0050Service {
  /**
   * コールセンター利用案内エリアの情報取得
   * @returns APIからのレスポンスデータ
   */
  public async callAPICAIA0050(): Promise<CAIA0050ResponseModel> {
    const caia0050RequestModel = new CAIA0050RequestModel()
    const caia0050ResponseModel: CAIA0050ResponseModel = <
      CAIA0050ResponseModel
    > await RestService.post(
      CommonUtil.getApiUrl(ApiUrlConstants.CAIA0050),
      caia0050RequestModel
    )
    return caia0050ResponseModel
  }
}
